import { HelpCircle } from "lucide-react"
import { Button } from "@/shared/ui/button"
import { BrandTitle } from "./brand-title"

interface HomeHeaderProps {
	onHelp?: () => void
}

export function HomeHeader({ onHelp }: HomeHeaderProps) {
	const iconButton = "rounded-full bg-white/10 text-foreground hover:bg-white/15"

	return (
		<header className="container mx-auto flex h-13 max-w-3xl items-center justify-between gap-2 px-3 sm:px-4">
			<BrandTitle />
			<div className="flex shrink-0 gap-1.5">
				{onHelp && (
					<Button
						type="button"
						variant="ghost"
						size="icon"
						aria-label="Показать тур по интерфейсу"
						onClick={onHelp}
						className={iconButton}
					>
						<HelpCircle className="size-5" />
					</Button>
				)}
			</div>
		</header>
	)
}
